import AddCity from "../../Components/Modals/AddCity";
import Table from "../../Components/Table";
import { deleteCityById, getAllCity } from "../../Services/MasterService";

const City = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Country",
            value: "country_name"
        },
        {
            label: "State",
            value: "state_name"
        },
        {
            label: "Cost Of Living",
            value: "avg_cost_living"
        },
        {
            label: "Alias",
            value: "alias"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCity data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCity}
            columns={columns}
            title={"City Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCityById}
        />
    );
}

export default City;